import { useCallback } from 'react'

interface ToastProps {
  title: string
  description?: string
  variant?: 'default' | 'destructive'
}

// Simple toast implementation using native browser alerts for now
// In a real application, this would be replaced with a proper toast library
export function useToast() {
  const toast = useCallback(({ title, description, variant }: ToastProps) => {
    const message = description ? `${title}: ${description}` : title
    
    if (variant === 'destructive') {
      // Use console.error for errors and alert for user feedback
      console.error(message)
      alert(`Error: ${message}`)
    } else {
      // Use console.log for success messages and alert for user feedback
      console.log(message)
      alert(message)
    }
  }, [])

  return { toast }
}